// extracted by mini-css-extract-plugin
export default {"globalNotificationWrapper":"index-module--globalNotificationWrapper--IKt1j"};